import React, { useTransition } from "react";
import { useTranslation } from "react-i18next";
import FailureWrapper from "./Failure.style";
import failureSorry from "../../assets/images/failure_sorry_image.svg";
import homeImg from "../../assets/images/home-img.svg";
import contactUsImg from "../../assets/images/contact-us-icon.svg";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import phoneKyc from "../../assets/images/phoneKyc.svg";
import faxKyc from "../../assets/images/faxKyc.svg";
import emailKyc from "../../assets/images/emailKyc.svg";
import poBox from "../../assets/images/poBoxKyc.svg";
import locationKyc from "../../assets/images/locationKyc.svg";

const Failure = (props) => {
	const { t } = useTranslation();
	return (
		<FailureWrapper>
			<React.Fragment>
				<div className="container main-container">
					<div className="failure-img-container d-flex justify-content-center">
						<img src={failureSorry} alt="failure" className="failure-img" />
					</div>
					<div className="failure-body-container d-flex flex-column justify-content-center align-items-center">
						<span className="failure-header">{t("Motor.UnfortunatelyProceed")}</span>
						<span className="failure-body">{t("Motor.ProceedFurther")}</span>
					</div>
					<div className="btn-sec d-flex align-items-center justify-content-center">
						<div className="left-btn d-flex align-items-center" 
						 onClick={() =>
							window.location.replace("https://www.tawuniya.com")
						  }
						>
							<img src={homeImg} alt="home" />
							<span className="back-text">{t("Motor.BackTawuniya")}</span>
						</div>
						<Button className="contact-us-btn">
							<img
								className="contact-us-img"
								src={contactUsImg}
								alt="Contact us"
							/>
							<span>{t("Motor.ContactUs")}</span>
						</Button>
					</div>
					<Card className="social-card4">
						<div className="d-flex justify-content-between">
							<div className="d-flex">
								<div className="col-md-0 col-lg-0 pt-3">
									<div className="container">
										<img src={phoneKyc} alt="phone" />
									</div>
								</div>

								<div className="col-md-3 col-lg-12">
									<p className="mainBannerPara medical-ptag pt-3">
										{t("contactUs.phone")}
									</p>
									<h6 className="mainBannerHeading">
										{t("contactUs.phone_no")}
									</h6>
								</div>
							</div>

							<div className="d-flex">
								<div className="col-lg-0 pt-3 fax_align">
									<div className="container">
										<img src={faxKyc} alt="fax" />
									</div>
								</div>

								<div className="col-md-3 col-lg-12 ">
									<p className="mainBannerPara medical-ptag pt-3">
										{t("contactUs.fax")}
									</p>
									<h6 className="mainBannerHeading">{t("contactUs.fax_no")}</h6>
								</div>
							</div>

							<div className="d-flex">
								<div className="col-md-0 col-lg-0 pt-3">
									<div className="container">
										<img src={emailKyc} alt="communication" />
									</div>
								</div>

								<div className="col-md-3 col-lg-12 emailui">
									<p className="mainBannerPara pt-3"> {t("contactUs.email")}</p>

									<h6 className="mainBannerHeading">
										{t("contactUs.contact_email")}
									</h6>
								</div>
							</div>
						</div>

						<hr className="hrtag" />

						<div className="d-flex bottom-sec-details">
							<div className="d-flex">
								<div className="col-md-0 col-lg-0 pt-1">
									<div className="container">
										<img src={poBox} alt="fax" />
									</div>
								</div>

								<div className="col-md-3 col-lg-12">
									<p className="mainBannerPara medical-ptag pt-1">
										{t("contactUs.box")}
									</p>
									<h6 className="mainBannerHeading">
										{t("contactUs.box_address")}
									</h6>
								</div>
							</div>

							<div className="d-flex">
								<div className="col-md-0 col-lg-0 pt-1">
									<div className="container">
										<img src={locationKyc} alt="location" />
									</div>
								</div>

								<div className="col-md-6 col-lg-6 pb-1">
									<p className="mainBannerPara medical-ptag pt-1">
										{t("contactUs.address")}
									</p>
									<h6 className="mainBannerHeading">
										{t("contactUs.address_txt")}
									</h6>
								</div>
							</div>
						</div>
					</Card>
				</div>
			</React.Fragment>
		</FailureWrapper>
	);
};

export default Failure;
